import { IOpenMarketProduct, IOpenMarketProductDetail } from '../../../interfaces/Product.interfaces';
import { customAxios } from '../../common/customAxios';

interface IGetOpenMarketProductByIdParams {
  productId: string;
}

export const getOpenMarketProductById = ({
  productId,
}: IGetOpenMarketProductByIdParams): Promise<IOpenMarketProductDetail> => {
  return customAxios.get(`/user-sell-tractors/${productId}`);
};
